import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, adminAuthHeaders } from "@/lib/api";
import { ADMIN_URL } from "@/lib/adminPath";

export default function AdminLogin() {
  const [username, setUsername] = useState("admin");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("rm_admin_token")) nav(ADMIN_URL);
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/admin/login", { username, password });
      localStorage.setItem("rm_admin_token", res.data.token);
      localStorage.setItem("rm_admin_role", res.data.role || "admin");
      localStorage.setItem("rm_admin_user", res.data.username || username);
      toast.success("Zalogowano");
      nav(ADMIN_URL);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Nieprawidłowe dane logowania");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="max-w-md mx-auto px-6 py-32">
      <div className="rm-card p-8">
        <h1 className="font-display text-2xl font-bold text-[#0f172a]">Panel administratora</h1>
        <p className="text-slate-500 text-sm mt-1">Zaloguj się, aby zarządzać zgłoszeniami.</p>
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="admin-login-form">
          <div>
            <label className="text-xs font-bold text-slate-700 uppercase tracking-wider">Nazwa użytkownika</label>
            <input
              data-testid="admin-username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="rm-input mt-1"
              placeholder="admin"
              autoComplete="username"
            />
          </div>
          <div>
            <label className="text-xs font-bold text-slate-700 uppercase tracking-wider">Hasło</label>
            <input
              data-testid="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="rm-input mt-1"
              placeholder="••••••••"
              autoComplete="current-password"
            />
          </div>
          <button data-testid="admin-login-submit" disabled={loading} className="rm-btn-primary w-full">
            {loading ? "Logowanie..." : "Zaloguj"}
          </button>
        </form>
      </div>
    </div>
  );
}
